export const DEFAULT_ACTION = 'screen/ForgetPassScreen/DEFAULT_ACTION';
export const UPDATE_INPUT = 'screen/ForgetPassScreen/UPDATE_INPUT';

export const FORGET_PASS = 'screen/ForgetPassScreen/FORGET_PASS';
export const FORGET_PASS_SUCCESS = 'screen/ForgetPassScreen/FORGET_PASS_SUCCESS';
export const FORGET_PASS_FAIL = 'screen/ForgetPassScreen/FORGET_PASS_FAIL';